<template>
  <div>
    <v-chip v-if="computedSignatureType"
            class="signature-chip detail-md-bold px-2 rounded-xl text-text-blue bg-surface-blue-subtle"
            :class="{'mr-2':isMultiEnvelopeOrChild || computedProviderType }"
            data-locator="signature-type-chip"
            variant="flat"
            size="small"
    >
      {{ $t(`project.signing-checklist.list.SigningChecklistTableItemSignatureChips.signatureType.${computedSignatureType}`) }}
    </v-chip>
    <v-chip
            v-if="computedProviderType"
            class="signature-chip detail-md-bold px-2 rounded-xl text-text-pink bg-surface-pink-subtle"
            :class="{'mr-2':isMultiEnvelopeOrChild}"
            data-locator="provider-type-chip"
            size="small"
            variant="flat"
    >
      {{ computedProviderType }}
    </v-chip>
    <v-chip v-if="isMultiEnvelopeOrChild"
            color="cyan"
            class="signature-chip detail-md-bold px-2 rounded-xl"
            :data-locator="isMultiEnvelope ? 'bulk-send-parent-chip' : 'bulk-send-child-chip' "
            size="small"
    >
      <!-- If we're both a child and a multi envelope, multi envelope wins for display purposes -->
      {{ isMultiEnvelope ? $t('project.signing-checklist.list.SigningChecklistTableItemSignatureChips.envelopeType.multiple') : $t('common.envelopeType.fromBulk')}}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'SigningChecklistTableItemSignatureChips',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    computedSignatureType () {
      if (this.item.hasOwnProperty('envelope')) {
        if (this.item.envelope.provider === 'pdf') {
          return 'pdf'
        } else if (this.item.envelope.signatureType === 'advanced') {
          return 'advanced'
        } else if (this.item.envelope.signatureType === 'simple') {
          return 'simple'
        } else if (this.item.envelope.signatureType === 'qualified') {
          return 'qualified'
        }
      }
      return null
    },
    computedProviderType () {
      if (this.item.hasOwnProperty('envelope')) {
        if (this.item.envelope.provider === 'oo') {
          return 'CertEurope'
        } else if (this.item.envelope.provider === 'ds') {
          return 'DocuSign'
        } else if (this.item.envelope.provider === 'ys') {
          return 'Yousign'
        }
      }
      return null
    },
    isMultiEnvelopeOrChild () {
      return this.isMultiEnvelope || this.isMultiEnvelopeChild
    },
    isMultiEnvelope () {
      return this.item.envelope.envelopeType === 'multiple'
    },
    isMultiEnvelopeChild () {
      return this.item.envelope?.parentMultienvelopeId
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.signature-chip:hover::before) {
  opacity: 0;
}
</style>
